import { useAuth } from 'auth/context/AuthContext';
import {
  useGetUsersVerificationStatusesByEmailQuery,
  useGetUsersVerificationStatusByEmailSubscription,
} from 'graphql/generated/hasura';

export const useGetUserVerifyStatuses = () => {
  const { user: loggedUser } = useAuth();

  const { data, loading, error, refetch } =
    useGetUsersVerificationStatusesByEmailQuery({
      fetchPolicy: 'no-cache',
      variables: {
        email: loggedUser?.email || '',
      },
    });

  useGetUsersVerificationStatusByEmailSubscription({
    fetchPolicy: 'no-cache',
    variables: {
      email: loggedUser?.email || '',
    },
    onSubscriptionData: () => refetch(),
  });

  return { userVerficationData: data, loading, error };
};
